import React, { useEffect, useState } from 'react';
import HamburgerSvg from '@/assets/assetfi/Hamburger';
import CommonButton from '@/component/pools/CommonButton';
import { ShortenAddr } from '@/lib/Shorten';
import { useTheme } from '@mui/material';
import { AppBar, IconButton, Toolbar } from '@mui/material';
import { useWeb3 } from '@/hooks/use-web3';
import ConnectInfo from '@/component/ConnectWallet/ConnectInfo';
import { useWeb3AuthConnect, useWeb3AuthUser } from '@web3auth/modal/react';

export default function Header({ handleDrawerToggle }: { handleDrawerToggle: () => void }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [addr, setAddress] = useState('');
  const { connect, isConnected } = useWeb3AuthConnect();
  const { userInfo: web3authUserInfo } = useWeb3AuthUser();
  const { address, clearWeb3Auth } = useWeb3();

  const theme = useTheme();
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (addr) {
      return;
    }
    (async () => {
      if (isConnected && web3authUserInfo) {
        setAddress(address);
        return;
      } else {
        setAddress('');
      }
      if (!addr && web3authUserInfo) {
        setAddress(address);
      }
    })();

    return () => {};
  }, [isConnected, address, web3authUserInfo]);


  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    console.log(addr);
    if (addr) {
      setAnchorEl(event.currentTarget);
      return;
    }
    clearWeb3Auth();
    await connect();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          borderBottom: `0.5px solid #d9d9d9`,
          display: { xs: 'flex', md: 'none' },
        }}
      >
        <Toolbar
          sx={{
            padding: '16px 24px',
            justifyContent: 'space-between',
            background: '#ffffff',
          }}
        >
          <IconButton aria-label="open drawer" edge="start" onClick={handleDrawerToggle}>
            <HamburgerSvg />
          </IconButton>
          <CommonButton
            bgColor={addr ? '#ffffff' : theme.brand.primary}
            color={addr ? theme.background.blue : '#ffffff'}
            text={addr ? ShortenAddr(addr) : 'Connect Wallet'}
            handleClick={handleClick}
            variant={addr ? 'h6' : 'subtitle2'}
            sx={{
              height: '32px',
              borderRadius: '20px',
              padding: '6px 20px 6px 20px',
              boxShadow: addr ? '0px 0px 4px 0px #00000026' : 'none',
            }}
            icon={addr ? 'symbol' : null}
          />
        </Toolbar>
        <ConnectInfo open={open} anchorEl={anchorEl} handleClose={handleClose} />
      </AppBar>
    </>
  );
}
